// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"305":"a3b38391","678":"b430826e"}[chunkId] + ".chunk.css";
};